module.exports = __webpack_public_path__ + "img/9788960511620.ed4ca5df.jpg";